var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../../Fct/createPlugin';
import { FctAddress } from '../../../../../Fct/generics';
import { swapExactEthForTokensParams } from '../../../../../Fct/plugins/uniswap/actions/params';
import { ROUTER_ADDRESSES } from '../../constants';
export var SwapExactETHForTokens = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'swapExactETHForTokens',
    getParams: function () { return (__assign(__assign({}, swapExactEthForTokensParams), { to: new FctAddress({ destination: 'sushiswap_router' }) })); },
    supportedContracts: ROUTER_ADDRESSES,
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
});
